import {
    AccountLabel,
    OtherCategory,
} from "@/entities/DataAssociation/Account.model";
import clsx from "clsx";
import { useCallback, useMemo } from "react";
import { ACCOUNT_LIST } from "../../constants/labeling.constants";
import { useRowSelection } from "../../hooks/useRowSelection";
import { LabelList } from "../LabelList";
import { AccountHintType } from "@/entities/DataAssociation/Draft.model";
import { LabelListStatementType } from "../../Labeling.types";
import { StatementType } from "@/entities/DataAssociation/File.model";

export function PseudoAccountList({
    selectedCategory,
    statementType,
}: {
    selectedCategory: OtherCategory;
    statementType: LabelListStatementType;
}) {
    const { onAccountSelection } = useRowSelection();

    const labels = useMemo(() => {
        return Object.values(ACCOUNT_LIST).filter((account) => {
            if (account.category !== selectedCategory) return false;

            if (statementType === LabelListStatementType.BALANCE_SHEET) {
                return (
                    account.statementType === StatementType.BALANCE_SHEET ||
                    account.statementType === StatementType.MIXED
                );
            }

            if (statementType === LabelListStatementType.INCOME_STATEMENT) {
                return (
                    account.statementType === StatementType.INCOME_STATEMENT ||
                    account.statementType === StatementType.MIXED
                );
            }

            return true;
        });
    }, [selectedCategory, statementType]);

    const onLabelSelection = useCallback(
        (label: AccountLabel) => {
            onAccountSelection({
                type: AccountHintType.NEW,
                accountName: ACCOUNT_LIST[label].name,
                label: label,
            });
        },
        [onAccountSelection, selectedCategory],
    );

    if (!labels) return null;

    return (
        <div className={clsx("flex flex-col pb-8")}>
            <LabelList labels={labels} onLabelSelection={onLabelSelection} />
        </div>
    );
}
